/**
 * Evminov Spinal Exercise Protocols Data
 */

export const exerciseProtocols = [
  {
    id: 'pediatric-dance-protocol',
    title: 'Pediatric Scoliosis & "Lying-Down Dancing"',
    target: 'Kids & Teens (Ages 3–15), Scoliosis & Natural Growth',
    angle: '8° – 12° Gentle Incline',
    duration: '5 – 10 Minutes',
    badge: 'Growth & Symmetry (+2–3")',
    description: 'Gamified rhythmic spinal micro-exercises set to upbeat music. Guarantees 100% bilateral muscular symmetry, safely unloads growing epiphyses, prevents juvenile idiopathic scoliosis, and unlocks natural growth height without boring medical gymnastics.',
    clinicalFocus: 'Bilateral Symmetry • Juvenile Scoliosis Prevention • Natural Growth Stimulation',
    steps: [
      'Grasp carriage handles at a gentle 8°–12° incline while lying supine on the resonant pine board.',
      'Play upbeat rhythmic music to turn the session into an emotionally engaging dance routine.',
      'Perform synchronized bilateral pelvic micro-tilts and alternating leg extensions ("lying-down dancing").',
      'Maintain strict left-right symmetry for 5–10 minutes 1–2 times daily as part of morning/evening routine.',
    ],
    videoThumbnail: '/images/gallery/youth-paired-traction.jpg',
    videoUrl: 'https://www.youtube.com/embed/GDLVNWynWF0',
  },
  {
    id: 'lumbar-traction',
    title: 'Lumbar L4-S1 Hernia Decompression',
    target: 'Lower Back & Sciatica',
    angle: '12° – 18° Incline',
    duration: '8 – 12 Minutes',
    badge: 'Most Prescribed',
    description: 'Relaxes deep lumbar multifidus muscles and widens narrowed intervertebral foramina along the L4–L5 and L5–S1 disc spaces. Generates negative intra-discal vacuum pressure that draws herniated disc material inward, instantly easing sciatic nerve impingement.',
    clinicalFocus: 'L4–S1 Vacuum Rehydration • Sciatic Nerve Relief • Multifidus Deep Core Relaxation',
    steps: [
      'Grasp carriage handles with arms relaxed above head while lying supine on the board.',
      'Allow calibrated gravity to gently traction the pelvis downward along the smooth wooden plane.',
      'Perform slow, micro-pelvic tilts (5-degree rotation) to pump synovial fluid into dehydrated discs.',
      'Breathe deeply into the lower diaphragm for 8–12 minutes without abrupt or jerking movements.',
    ],
    videoThumbnail: '/images/authentic/exercise-bridge-pelvic.jpg',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ', // Placeholder or demo
  },
  {
    id: 'cervical-glisson',
    title: 'Glisson Loop Cervical Traction',
    target: 'Neck, C1-C7 & Tension Headaches',
    angle: '8° – 12° Incline',
    duration: '5 – 8 Minutes',
    badge: 'Migraine & Tech Neck',
    description: 'Safely decompresses the delicate cervical spine from C1 to C7 under calibrated low-angle traction. Opens compressed intervertebral foramina, relieves pinched occipital nerves, restores natural cervical lordosis, and eliminates stubborn occipital tension from prolonged screen exposure.',
    clinicalFocus: 'C1–C7 Foraminal Decompression • Suboccipital Tension Release • Tech-Neck Reversal',
    steps: [
      'Fasten the padded Glisson collar snugly and comfortably under the chin and occiput.',
      'Lie comfortably on the inclined pine plane with knees flexed and feet resting flat.',
      'Gently slide downward 1–2 inches until gentle, therapeutic axial neck traction is achieved.',
      'Hold still for 5 minutes, followed by micro-nodding rotations of no more than 10 degrees.',
    ],
    videoThumbnail: '/images/authentic/evminov-glisson-loop-cervical.jpg',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
  },
  {
    id: 'athletic-restore',
    title: 'Post-Workout Spinal Restoration (After Deadlifts & Squats)',
    target: 'Athletes, Powerlifters & CrossFitters',
    angle: '22° – 30° Incline',
    duration: '10 – 15 Minutes',
    badge: 'Heavy Lifting Essential',
    description: 'Reverses severe axial compressive loads and disc crushing caused by heavy barbell squats, deadlifts, and high-impact sports. Inverted hanging traction decompresses overloaded facet joints, releases hypertonic erector spinae spasms, and accelerates spinal recovery.',
    clinicalFocus: 'Axial Load Decompression • Heavy Squat Recovery • Intervertebral Shock Rebound',
    steps: [
      'Hook feet securely into the soft padded foot holders with head facing downward along the board.',
      'Extend arms overhead, feeling complete latissimus dorsi, lumbar, and thoracolumbar fascial lengthening.',
      'Execute gentle rhythmic side-waving spinal flexions to circulate fluid through compressed facet joints.',
      'Conclude with 3 minutes of total passive relaxation at a 25-degree incline to lock in disc space.',
    ],
    videoThumbnail: '/images/authentic/exercise-reverse-traction.jpg',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
  },
  {
    id: 'thoracic-posture',
    title: 'Thoracic Extension & Kyphosis Correction',
    target: 'Mid-Back, Slouching & Shoulder Mobility',
    angle: '15° – 20° Incline',
    duration: '7 – 10 Minutes',
    badge: 'WFH Posture',
    description: 'Counteracts desk hunching, rounded shoulders, and computer slouch by actively mobilizing stiff T1–T12 thoracic vertebrae. Gently stretches contracted pectoral and anterior chest fascia while activating mid-trapezius and rhomboid posture stabilizers against gravity.',
    clinicalFocus: 'T1–T12 Thoracic Mobilization • Scapular Retraction • Pectoral Fascial Opening',
    steps: [
      'Position middle thoracic back directly over the anatomical flex zone of the inclined board.',
      'Open arms wide into a "T" position, letting shoulder blades retract naturally against the smooth wood.',
      'Slowly sweep arms upward into a "Y" position overhead while inhaling deeply into the ribcage.',
      'Repeat 12 slow cycles with controlled breathing, maintaining gentle isometric core stabilization.',
    ],
    videoThumbnail: '/images/authentic/exercise-prone-extension.jpg',
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
  },
];
